import { stripHtml } from "AC/helpers/string";
var Sorting = /** @class */ (function () {
    function Sorting(form) {
        this.form = form;
        this.columns = form.getColumns();
        this.setting = form.getElement().querySelector('[data-setting="sorting-preference"]');
        this.selectElement = this.setting.querySelector('[name="sorting"]');
        this.init();
    }
    Sorting.prototype.init = function () {
        var _this = this;
        this.columns.forEach(function (column) {
            if (_this.isSortable(column)) {
                var option = document.createElement('option');
                option.value = column.getName();
                option.text = stripHtml(column.getJson().label);
                if (!option.text) {
                    option.text = column.getElement().querySelector('.column_type .inner').innerText;
                }
                _this.selectElement.appendChild(option);
            }
        });
        var current = this.selectElement.dataset.sorting;
        this.selectElement.querySelectorAll("[value=\"" + current + "\"]").forEach(function (e) { return e.selected = true; });
    };
    Sorting.prototype.isSortable = function (column) {
        return column.getElement().querySelectorAll('table[data-setting="sort"] input[value="on"]:checked').length > 0;
    };
    return Sorting;
}());
export default Sorting;
